import { Line } from 'vue-chartjs'
import * as d3 from "d3";
export default {
  extends: Line,
  data: () => ({
    labels: [],
    data: [],
    br: [],
    lf: [],
    rf: [],
    stf: [],
    // p4sthm: [],
    // phr: [],
    // rr: [],
    // pm: [],
    // rff: [],
    // sgr: [],
    // svf: [],
    // bcr: [],
    // bm: [],
    // bb: [],
    // pr: [],
    // pc: [],
    // ps: [],
    // i1: [],
    // df: [],
    // cc: [],
    // ohw: [],
    // s90: [],
    // s80: [],
    // s70: [],
    // gf: [],
    // el: [],
    // sc: [],
    spotifyse: [],
    fullLabels: [],
    fullBr: [],
    fullLf: [],
    fullRf: [],
    fullStf: [],
    fullSpotifyse: []
  }),
  mounted () {
    this.logTest()
    this.loadData()
    // react to date range changes
    if (this.$store && this.$store.watch) {
      this.$store.watch(
        state => state.dateRange,
        () => {
          this.filterAndRender()
        }
      )
    }
  },
  methods: {
      loadData: function() {
        d3.csv('https://radio-kollen-public.s3-eu-west-1.amazonaws.com/percentage-neg-collection.csv', (data) => {
            this.fullBr.push(parseInt(data['br']));
            this.fullLf.push(parseInt(data['lf']));
            this.fullRf.push(parseInt(data['rf']));
            this.fullStf.push(parseInt(data['stf']));
            // this.phr.push(parseInt(data['phr']));
            // this.rr.push(parseInt(data['rr']));
            // this.pm.push(parseInt(data['pm']));
            // this.rff.push(parseInt(data['rff']));
            // this.sgr.push(parseInt(data['sgr']));
            // this.svf.push(parseInt(data['svf']));
            // this.bcr.push(parseInt(data['bcr']));
            // this.bm.push(parseInt(data['bm']));
            // this.bb.push(parseInt(data['bb']));
            // this.pr.push(parseInt(data['pr']));
            // this.pc.push(parseInt(data['pc']));
            // this.ps.push(parseInt(data['ps']));
            // this.i1.push(parseInt(data['i1']));
            // this.df.push(parseInt(data['df']));
            // this.cc.push(parseInt(data['cc']));
            // this.ohw.push(parseInt(data['ohw']));
            // this.s90.push(parseInt(data['s90']));
            // this.s80.push(parseInt(data['s80']));
            // this.s70.push(parseInt(data['s70']));
            // this.gf.push(parseInt(data['gf']));
            // this.el.push(parseInt(data['el']));
            // this.sc.push(parseInt(data['sc']));
            this.fullSpotifyse.push(parseInt(data['spotifyse']));
            this.fullLabels.push(data['date']);
        }).then( () => {
            this.filterAndRender()
        }
        );
      },
      filterAndRender: function() {
        const start = this.$store && this.$store.state.dateRange.start ? this.$store.state.dateRange.start : null
        const end = this.$store && this.$store.state.dateRange.end ? this.$store.state.dateRange.end : null
        const labels = []
        const br = []
        const lf = []
        const rf = []
        const stf = []
        const spotifyse = []
        for (let i = 0; i < this.fullLabels.length; i++) {
          const date = this.fullLabels[i]
          if ((start === null || date >= start) && (end === null || date <= end)) {
            labels.push(date)
            br.push(this.fullBr[i])
            lf.push(this.fullLf[i])
            rf.push(this.fullRf[i])
            stf.push(this.fullStf[i])
            spotifyse.push(this.fullSpotifyse[i])
          }
        }
        this.labels = labels
        this.br = br
        this.lf = lf
        this.rf = rf
        this.stf = stf
        this.spotifyse = spotifyse
        this.renderChart({
                  labels: this.labels,
                  datasets: [
                    {
                      type: 'line',
                      label: 'Bandit Rock',
                      borderColor: '#4C4C4C',
                      data: this.br,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'Lugna Favoriter',
                      borderColor: '#701447',
                      data: this.lf,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'RIX FM',
                      borderColor: '#0089D2',
                      data: this.rf,
                      fill: false

                    },
                    {
                      type: 'line',
                      label: 'STAR FM',
                      borderColor: '#662D91',
                      data: this.stf,
                      fill: false
                    },
                    // {
                    //   type: 'line',
                    //   label: 'Power Hit Radio',
                    //   borderColor: '#D30008',
                    //   data: this.phr,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Radio Rainbow',
                    //   borderColor: '#F03A89',
                    //   data: this.rr,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Power Millennium',
                    //   borderColor: '#181818',
                    //   data: this.pm,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'RIX FM Fresh',
                    //   borderColor: '#AACE37',
                    //   data: this.rff,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Skärgårdsradion',
                    //   borderColor: '#6491CF',
                    //   data: this.sgr,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Svenska Favoriter',
                    //   borderColor: '#0071BC',
                    //   data: this.svf,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Bandit Classic Rock',
                    //   borderColor: '#D3B34E',
                    //   data: this.bcr,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Bandit Metal',
                    //   borderColor: '#929496',
                    //   data: this.bm,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Bandit Ballads',
                    //   borderColor: '#8731A3',
                    //   data: this.bb,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Pirate Rock',
                    //   borderColor: '#D6C100',
                    //   data: this.pr,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Power Club',
                    //   borderColor: '#8E188E',
                    //   data: this.pc,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Power Street',
                    //   borderColor: '#82DBEC',
                    //   data: this.ps,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Indie 101',
                    //   borderColor: '#13B47A',
                    //   data: this.i1,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Dansbandsfavoriter',
                    //   borderColor: '#EB297B',
                    //   data: this.df,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Country Classics',
                    //   borderColor: '#624A32',
                    //   data: this.cc,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'One Hit Wonders',
                    //   borderColor: '#FFB100',
                    //   data: this.ohw,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Star 90\'s',
                    //   borderColor: '#FFC507',
                    //   data: this.s90,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Star 80\'s',
                    //   borderColor: '#652D8F',
                    //   data: this.s80,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Star 70\'s',
                    //   borderColor: '#F072AB',
                    //   data: this.s70,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Gamla Favoriter',
                    //   borderColor: '#FF7600',
                    //   data: this.gf,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Electro Lounge',
                    //   borderColor: '#F47D26',
                    //   data: this.el,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Soul Classics',
                    //   borderColor: '#EF5A28',
                    //   data: this.sc,
                    //   fill: false
                    // },
                    {
                      type: 'line',
                      label: 'Spotify Sverige (Top 50)',
                      borderColor: 'rgb(30, 215, 96)',
                      data: this.spotifyse,
                      fill: false
                    }
                    /** 
                     * Mer P4:
                     * 28/41/167
                     * https://sverigesradio.se/diverse/appdata/isidor/files/3113/9463.pdf
                     * 
                    */
                  ]}, {
                    title: {
                      display: false,
                      text: ''
                    },
                    scales: {
                      yAxes: [{
                        stacked: false,
                        scaleLabel: {
                          display: true,
                          labelString: 'Andel musiker som är kvinnliga (%)'
                        },
                        ticks: {
                          beginAtZero: true,
                          suggestedMax: 50,
                        },
                      }],
                      xAxes: [ {
                        stacked: false,
                        categoryPercentage: 0.5,
                        barPercentage: 1
                      }]
                    },
                    legend: {
                      display: true
                    },
                    responsive: true,
                    maintainAspectRatio: false
                  }
                )
      },
      logTest: function() {
          //console.log("Hello!")
      }
  }
}